import { render, staticRenderFns } from "./RuleGroup.vue?vue&type=template&id=4455972e&scoped=true"
import script from "./RuleGroup.vue?vue&type=script&lang=js"
export * from "./RuleGroup.vue?vue&type=script&lang=js"
import style0 from "./RuleGroup.vue?vue&type=style&index=0&id=4455972e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4455972e",
  null
  
)

export default component.exports